module.exports = __webpack_public_path__ + "static/media/Block.ac1602be.svg";